import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import {
  KcDataService
} from '../../../kc-data.service'
import { KcChooseExistingViewData } from '../../../interfaces/kc-data.interface'
@Component({
  selector: 'customer-portal-revolution-choose-existing',
  templateUrl: './revolution-choose-existing.component.html'
})
export class RevolutionChooseExistingComponent implements OnInit {
  constructor (private readonly kcDataService: KcDataService) {}

  @ViewChild('chooseExistingForm', { static: true })
  private readonly formRef: ElementRef

  public form = new FormGroup({
    type: new FormControl<string | null>(null)
  })

  public viewData: KcChooseExistingViewData
  public submitting: boolean
  background = ''
  ngOnInit (): void {
    this.viewData = this.kcDataService.getViewData() as KcChooseExistingViewData
  }

  public submit (): void {
    this.submitting = true

    // submit form
    const formElement = this.formRef.nativeElement as HTMLFormElement
    formElement.submit()
  }

  changeBackground (type): void {
    this.background = type
  }
}
